import { ChangeSessionReason, ChangeSessionReasonType, UserRole } from '@uplift/types';

import { restClient } from '../../client';

export const getChangeAppointmentReasons = (type: ChangeSessionReasonType, roles: UserRole[]) =>
  restClient.request<{ data: ChangeSessionReason[] }>(
    '/api/v1/appointment/change_appointment_reasons',
    {
      method: 'POST',
      data: {
        type: type,
        roles: roles,
      }
    }
  );


export const getChangeAppointmentReasonById = (reasonId: string) => restClient.request<{ data: ChangeSessionReason }>(
  `/api/v1/appointment/change_appointment_reason/${reasonId}`
);
